/**
 * 这里用于区分不同应用场景的数据，
 * 目前全是针对导航栏相关的数据
 */

import { Cat1, Cat2, Cat3, channelType, projectType } from '@/common/const.js'
import { CacheIsWordOrExcelABTest, CacheSessionGetChannel, CacheSessionGetProjectType } from '@/common/cache.js'

/** data.js文件数据的关键字，在其他文件中，用于判断 */
export const isMore = 'isMore'
export const isMy = 'isMy'
export const isCustomer = 'isCustomer'
export const typeOpenBrowser = 'openBrowser'

export const customerServiceUrl = 'https://wpa1.qq.com/bM6XDfDw?_type=wpa&qidian=true' // 客服浏览器链接

const moreUrlObj = {
  ppt: {
    [channelType.duba]: 'https://minisite.keniu.com/classify?cat1=1&channel=duba&source=kmini_duba_ofp_sidemore',
    [channelType.dg]: 'https://minisite.keniu.com/classify?cat1=1&channel=dg&source=kmini_dg_ofp_sidemore',
    [channelType.exe]: 'https://minisite.keniu.com/classify?cat1=1&channel=exe&source=kmini_exe_ofp_sidemore',
    [channelType.sys]: 'https://o.keniu.com/?source=web_sys_ofp_sidemore',
    [channelType.wall]: 'https://o.keniu.com/?source=web_wall_ofp_sidemore',
    [channelType.pdf]: 'https://o.keniu.com/?source=kweb_pdf_ofp_sidemore',
    [channelType.pic]: 'https://o.keniu.com/?source=kweb_pic_ofp_sidemore',
    [channelType.hy]: 'https://o.keniu.com/?source=kweb_hy_ofp_sidemore',
  },
  pptDefault: 'https://o.keniu.com/?source=web_ofp_sidemore',
  excel: {
    [channelType.duba]: 'https://minisite.keniu.com/classify?cat1=31&channel=duba&source=kmini_duba_ofe_sidemore',
    [channelType.dg]: 'https://minisite.keniu.com/classify?cat1=31&channel=dg&source=kmini_dg_ofe_sidemore',
    [channelType.exe]: 'https://minisite.keniu.com/classify?cat1=31&channel=exe&source=kmini_exe_ofe_sidemore',
    [channelType.sys]: 'https://o.keniu.com/?source=web_sys_ofe_sidemore',
    [channelType.wall]: 'https://o.keniu.com/?source=web_wall_ofe_sidemore',
    [channelType.pdf]: 'https://o.keniu.com/?source=kweb_pdf_ofe_sidemore',
    [channelType.pic]: 'https://o.keniu.com/?source=kweb_pic_ofe_sidemore',
    [channelType.hy]: 'https://o.keniu.com/?source=kweb_hy_ofe_sidemore',
  },
  excelDefault: 'https://o.keniu.com/?source=web_ofe_sidemore',
  word: {
    [channelType.duba]: 'https://minisite.keniu.com/classify?cat1=16&channel=duba&source=kmini_duba_ofw_sidemore',
    [channelType.dg]: 'https://minisite.keniu.com/classify?cat1=16&channel=dg&source=kmini_dg_ofw_sidemore',
    [channelType.exe]: 'https://minisite.keniu.com/classify?cat1=16&channel=exe&source=kmini_exe_ofw_sidemore',
    [channelType.sys]: 'https://o.keniu.com/?source=web_sys_ofp_sidemore',
    [channelType.wall]: 'https://o.keniu.com/?source=web_wall_ofp_sidemore',
    [channelType.pdf]: 'https://o.keniu.com/?source=kweb_pdf_ofp_sidemore',
    [channelType.pic]: 'https://o.keniu.com/?source=kweb_pic_ofp_sidemore',
    [channelType.hy]: 'https://o.keniu.com/?source=kweb_hy_ofp_sidemore',
  },
  wordDefault: 'https://o.keniu.com/?source=web_ofp_sidemore',
}

const getUrlFunc = () => { // 不同场景，导航栏【更多】提供的链接不同，打开方式也不同
  const channel = CacheSessionGetChannel()
  const projecttype = CacheSessionGetProjectType()
  return moreUrlObj[projecttype]?.[channel] || (moreUrlObj[projecttype + 'Default'])
}

// 需要保留完整分类层级，不然，存在cat3有值，cat2：0的情况。0代表全部；
// 如果要修改，注意layout.vue文件的setActiveIndex方法，与该数据强相关
/**
 * name: 显示名称
 * icon: 侧边栏icon，需要在aside页面新增对应的icon
 * cat*: 侧边栏对应的分类id
 * activeIndex: url进入页面时，匹配cat*，反向设置activeIndex
 * downType: 下载时提供给客户端的下载类型，查看客户端下载接口：ClientDownload
 * recommendList: 热门搜索
 */

const recommendListPPT = [
  { value: '总结汇报' },
  { value: '课件' },
  { value: '小清新' },
  { value: '建党' },
  { value: '答辩' },
  { value: '策划' }
]

const recommendListWord = [
  { value: '简历' },
  { value: '报告' },
  { value: '教学' },
  { value: '试卷' }
]

/** 非分类信息 */
const commonAsideArr = [
  { [isCustomer]: true, type: typeOpenBrowser, icon: 'icon_customer', name: '客服', url: customerServiceUrl },
  { [isMore]: true, icon: 'icon_aside_more', name: '更多', getUrl: getUrlFunc }
]

/** 导航栏，我的 */
const asideMy = { [isMy]: true, icon: 'icon_my', activeIndex: 5, name: '我的' }

const allProjectAsideMap = {
  ppt: {
    unshow: [],
    asideArr: [
      {
        name: '总结', icon: 'icon_aside_ppt1', [Cat1]: 1, [Cat2]: 190, [Cat3]: 0,
        activeIndex: 0,
        downType: 0,
        recommendList: recommendListPPT
      },
      {
        name: '教育', icon: 'icon_aside_ppt2', [Cat1]: 1, [Cat2]: 191, [Cat3]: 0,
        activeIndex: 1,
        downType: 0,
        recommendList: recommendListPPT
      },
      {
        name: '党政', icon: 'icon_aside_ppt3', [Cat1]: 1, [Cat2]: 193, [Cat3]: 0,
        activeIndex: 2,
        downType: 0,
        recommendList: recommendListPPT
      },
      {
        name: '策划', icon: 'icon_aside_ppt4', [Cat1]: 1, [Cat2]: 194, [Cat3]: 0,
        activeIndex: 3,
        downType: 0,
        recommendList: recommendListPPT
      },
      {
        name: '答辩', icon: 'icon_aside_ppt5', [Cat1]: 1, [Cat2]: 192, [Cat3]: 0,
        activeIndex: 4,
        downType: 0,
        recommendList: recommendListPPT
      },
      {
        name: '图示', icon: 'icon_aside_ppt6', [Cat1]: 1, [Cat2]: 368, [Cat3]: 0,
        activeIndex: 5,
        downType: 0,
        recommendList: recommendListPPT
      },
      ...commonAsideArr
    ]
  },

  excel: {
    unshow: [],
    defaultActive: 1,
    asideArr: [
      {
        name: '财务', icon: 'icon_aside_excel2', [Cat1]: 31, [Cat2]: 201, [Cat3]: 0,
        activeIndex: 0,
        downType: 4,
        recommendList: [
          { value: '财务' },
          { value: '收入' },
          { value: '工资' }
        ]
      },
      {
        name: '进销存', icon: 'icon_aside_excel4', [Cat1]: 31, [Cat2]: 204, [Cat3]: 0,
        activeIndex: 1,
        downType: 4,
        recommendList: [
          { value: '报价单' },
          { value: '库存' },
          { value: '采购' }
        ]
      },
      {
        name: '生产', icon: 'icon_aside_excel1', [Cat1]: 31, [Cat2]: 364, [Cat3]: 0,
        activeIndex: 2,
        downType: 4,
        recommendList: [
          { value: '生产' },
          { value: '订单' },
          { value: '项目' },
          { value: '研发' }
        ]
      },
      {
        name: '行政', icon: 'icon_aside_excel3', [Cat1]: 31, [Cat2]: 202, [Cat3]: 0,
        activeIndex: 3,
        downType: 4,
        recommendList: [
          { value: '考勤' },
          { value: '绩效' },
          { value: '招聘' }
        ]
      },
      {
        name: '市场', icon: 'icon_aside_excel5', [Cat1]: 31, [Cat2]: 205, [Cat3]: 0,
        activeIndex: 4,
        downType: 4,
        recommendList: [
          { value: '销售' },
          { value: '客户 ' },
          { value: '渠道' },
          { value: '售后' }
        ]
      },
      {
        name: '教育', icon: 'icon_aside_excel6', [Cat1]: 31, [Cat2]: 206, [Cat3]: 0,
        activeIndex: 5,
        downType: 4,
        recommendList: [
          { value: '花名册' },
          { value: '课程表' },
          { value: '数学表' }
        ]
      },
      ...commonAsideArr
    ],
    asideArrABTest: [
      {
        name: 'PPT', icon: 'icon_ppt', [Cat1]: 1, [Cat2]: 0, [Cat3]: 0,
        activeIndex: 0,
        downType: 0,
        numberCol: 1, // abTest专用
        projectType: projectType.ppt,
        recommendList: [
          { value: '总结汇报' },
          { value: '教学' },
          { value: '关系图' },
          { value: '营销策划' },
          { value: '论文答辩' }
        ]
      },
      {
        name: 'Excel', icon: 'icon_excel', [Cat1]: 31, [Cat2]: 0, [Cat3]: 0,
        activeIndex: 1,
        downType: 4,
        recommendList: [
          { value: '财务报表' },
          { value: '工作计划' },
          { value: '记账' },
          { value: '库存' }
        ]
      },
      {
        name: 'word', icon: 'icon_word', [Cat1]: 16, [Cat2]: 0, [Cat3]: 0,
        activeIndex: 2,
        downType: 0,
        recommendList: [
          { value: '简历' },
          { value: '合同' },
          { value: '活动策划' }
        ]
      },
      {
        name: '设计', icon: 'icon_design', [Cat1]: 210, [Cat2]: 0, [Cat3]: 0,
        activeIndex: 3,
        downType: 3,
        recommendList: [
          { value: '海报' },
          { value: '插画' }
        ]
      },
      {
        name: '元素', icon: 'icon_element', [Cat1]: 207, [Cat2]: 0, [Cat3]: 0,
        activeIndex: 4,
        downType: 3,
        recommendList: [
          { value: '图标' },
          { value: '卡通' }
        ]
      },
      ...commonAsideArr,
      asideMy
    ]
  },

  word: {
    unshow: [],
    defaultActive: 2,
    asideArr: [
      {
        name: '简历', icon: 'icon_aside_word1', [Cat1]: 16, [Cat2]: 197, [Cat3]: 0,
        activeIndex: 0,
        downType: 0,
        recommendList: recommendListWord
      },
      {
        name: '范文', icon: 'icon_aside_word2', [Cat1]: 16, [Cat2]: 342, [Cat3]: 0,
        activeIndex: 1,
        downType: 0,
        recommendList: recommendListWord
      },
      {
        name: '法律', icon: 'icon_aside_word3', [Cat1]: 16, [Cat2]: 199, [Cat3]: 0,
        activeIndex: 2,
        downType: 0,
        recommendList: recommendListWord
      },
      {
        name: '行政', icon: 'icon_aside_word4', [Cat1]: 16, [Cat2]: 198, [Cat3]: 0,
        activeIndex: 3,
        downType: 0,
        recommendList: recommendListWord
      },
      {
        name: '教育', icon: 'icon_aside_word5', [Cat1]: 16, [Cat2]: 349, [Cat3]: 0,
        activeIndex: 4,
        downType: 0,
        recommendList: recommendListWord
      },
      ...commonAsideArr
    ],
    asideArrABTest: [
      {
        name: 'PPT', icon: 'icon_ppt', [Cat1]: 1, [Cat2]: 0, [Cat3]: 0,
        activeIndex: 0,
        downType: 0,
        numberCol: 1,
        projectType: projectType.ppt,
        recommendList: [
          { value: '总结汇报' },
          { value: '教学' },
          { value: '关系图' },
          { value: '营销策划' },
          { value: '论文答辩' }
        ]
      },
      {
        name: 'Excel', icon: 'icon_excel', [Cat1]: 31, [Cat2]: 0, [Cat3]: 0,
        activeIndex: 1,
        downType: 4,
        recommendList: [
          { value: '财务报表' },
          { value: '工作计划' },
          { value: '记账' },
          { value: '库存' }
        ]
      },
      {
        name: 'word', icon: 'icon_word', [Cat1]: 16, [Cat2]: 0, [Cat3]: 0,
        activeIndex: 2,
        downType: 0,
        recommendList: [
          { value: '简历' },
          { value: '合同' },
          { value: '活动策划' }
        ]
      },
      {
        name: '设计', icon: 'icon_design', [Cat1]: 210, [Cat2]: 0, [Cat3]: 0,
        activeIndex: 3,
        downType: 3,
        recommendList: [
          { value: '海报' },
          { value: '插画' }
        ]
      },
      {
        name: '元素', icon: 'icon_element', [Cat1]: 207, [Cat2]: 0, [Cat3]: 0,
        activeIndex: 4,
        downType: 3,
        recommendList: [
          { value: '图标' },
          { value: '卡通' }
        ]
      },
      ...commonAsideArr,
      asideMy
    ]
  },
}

const specialLayoutMap = {
  ppt: [2],
  excel: [],
  word: []
}
/** 根据projecttype，展示列表的3列所在下标 */
export const getProjectSpacialList = (type) => {
  return specialLayoutMap[type]
}

/** 根据projecttype获取导航栏 */
export const getProjectAsideList = (type) => {
  const channel = CacheSessionGetChannel()
  const isExcelOrWordABTest = CacheIsWordOrExcelABTest() && channel === channelType.duba
  const project = allProjectAsideMap[type]

  /** ppt没有，得兼容 */
  return project?.[isExcelOrWordABTest ? 'asideArrABTest' : 'asideArr'] || project.asideArr
}

/** 根据projecttype获取默认选中导航 */
export const getProjectDefaultActive = (type) => {
  return allProjectAsideMap[type]?.defaultActive
}

/** 根据projecttype， 获取项目对应不展示模块 */
export const getProjectUnshowList = (type) => {
  return allProjectAsideMap[type].unshow
}
